'use client'
import React from 'react';
import ResetOffsetButton from '@/components/MainClockControls';
import { Analytics } from '@vercel/analytics/react';
import TimeFormatToggle from '@components/MainClockControls/TimeFormatToggle';
import LogRocket from 'logrocket';
import Clock from '@components/Clock';
import { CreateMeetingCard } from '@components/Meeting/create-meeting-card';
import { MinimalCitiesCard } from '@components/Meeting/minimal-cities-card';
import CitySearch from '@components/CityManagement/CitySearch';
import ClockSwitcher from '@components/ClockSwitcher';
import { useClockSettingsStore } from '@store/timeStore';
import GradientClock from '@components/Clock/GradientClock';
import FeedbackModal from '@components/Feedback/FeedbackModal';

// Initialize LogRocket
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  LogRocket.init('98k6pd/timeywimey');
  console.log('LogRocket initialized in production');
} else {
  console.log('LogRocket not initialized (development mode)');
}

const Feedback = () => {
  return (
    <div className="py-4 w-full flex justify-center items-center">
      <FeedbackModal />
    </div>
  )
}

export default function Home() {
  const { clockMode } = useClockSettingsStore();

  const SelectedClock = clockMode === "clock" ? Clock : GradientClock;
  const SelectedCard = clockMode === "clock" ? MinimalCitiesCard : CreateMeetingCard;

  return (
    <>
      <main className="min-h-screen flex flex-col w-screen overflow-x-hidden landscape:min-h-0 landscape:md:flex-row landscape:md:h-screen landscape:md:overflow-hidden">
        {/* Header - Full width in landscape on larger screens */}
        <div className="w-full mt-2 landscape:md:fixed landscape:md:top-0 landscape:md:z-10">
          <div className="w-full h-14 flex justify-between items-center px-4 text-blue-500">
            <ClockSwitcher />
            <ResetOffsetButton />
            <TimeFormatToggle />
          </div>
        </div>

        {/* Left column in landscape (md+) / Top section in portrait & mobile landscape */}
        <div className="w-full landscape:md:w-1/2 landscape:md:h-screen landscape:md:flex landscape:md:flex-col landscape:md:justify-center landscape:md:gap-6">
          <SelectedClock />
          <div className="px-4 pt-4 landscape:md:pt-0">
            <CitySearch />
          </div>
          <div className="landscape:md:hidden px-4 pb-4">
            <SelectedCard />
            <Feedback />
          </div>
        </div>

        {/* Right column in landscape (md+) */}
        <div className="w-full landscape:md:w-1/2 landscape:md:h-screen landscape:md:overflow-y-auto landscape:md:pt-20">
          <div className="hidden landscape:md:block w-full px-4 pb-4">
            <SelectedCard />
            <Feedback />
          </div>
        </div>
      </main>
      <Analytics />
    </>
  );
}
